import React, { memo } from 'react'
import styled from 'styled-components'
import { constWidgetSize } from './utils/scale/constWidgetSize'
import { getNumberOfVisibleAxes } from './utils/widgets/getNumberOfVisibleAxes copy'
import { Chart, ChartContainer } from './Chart'
import { Ruler } from './Ruler'
import { CropItem, PdfRender } from '../api/utils/types'
import { getSpanCropItem } from './utils/widgets/getSpanCropItem'
import { widgetIsDepth } from './utils/widgets/getWidgetSpan'

export interface ChartProps {
    charts: any[]
    height
    span: string
    spanDepth: string
    widthIn: number
    heightIn: number
    onLoadQueries: () => void
}

export interface ChartsProps {
    heightHeaderPx: number
    heightFooterPx: number
    pdfRender: PdfRender
    charts: any[]
    cropItem: CropItem
    widthIn: number
    filters: any
    pickerUnit: string
    onLoadQueries: () => void
}
export const Charts = memo(function ChartsRender({
    charts,
    cropItem,
    widthIn,
    heightHeaderPx,
    heightFooterPx,
    pdfRender,
    filters,
    pickerUnit,
    onLoadQueries
}: ChartsProps) {
    if (!charts || charts.length == 0) {
        return null
    }

    const queriesByChartLayer = []
    const numberOfVisibleAxes = getNumberOfVisibleAxes(charts.map(({ widget }) => widget))
    const [span, spanDepth] = getSpanCropItem(cropItem)

    const heightIn = Math.max(cropItem.ticksDepth, cropItem.ticksTime)
    
    return (
        <div
            style={{
                height: `calc(${heightIn + 1}in + ${heightHeaderPx}px)`,
                display: 'flex',
                width: `calc(${widthIn}in)`
            }}
            className="render-pdf-chart-container"
        >
            <div
                style={{
                    position: 'relative',
                    width: `${widthIn}in`
                }}
            >
                <Ruler
                    leftLabelIsDepth={widgetIsDepth(charts[0]?.widget)}
                    heightIn={heightIn}
                    headerPx={heightHeaderPx}
                    pdfRender={pdfRender}
                    cropItem={cropItem}
                    pickerUnit={pickerUnit}
                />
                <ChartsContainer>
                    {charts.map(({ widget, width }, position) => {
                        const widgetID = widget.id
                        return (
                            <Chart
                                key={`chart-view-${widgetID}-${position}`}
                                position={position}
                                cropItem={cropItem}
                                width={width}
                                span={span}
                                spanDepth={spanDepth}
                                widgetID={widgetID}
                                widget={widget}
                                filters={filters}
                                pdfRender={pdfRender}
                                chartHeader={heightHeaderPx}
                                paddingBottom={heightFooterPx}
                                numberOfVisibleAxes={numberOfVisibleAxes}
                                onLoad={() => {
                                    queriesByChartLayer.push(position)
                                    if (queriesByChartLayer.length == charts.length) {
                                        onLoadQueries()
                                    }
                                }}
                            />
                        )
                    })}
                </ChartsContainer>
            </div>
        </div>
    )
})

const ChartsContainer = styled.div`
    width: calc(100% - 100px); //https://platform.intelie.com/developers/web-application/browser-compatibility    
    pointer-events: none !important;    
    margin-left: 50px;
    position: relative;
    display: inline-flex;
    
    .widget-header {
        height: ${constWidgetSize.title}px !important;
        overflow: hidden;
        .widget-title {
            display: block;
        }        
    }
    .widget-title{
        border-bottom: solid 1px var(--gray-400) !important;
    }
    
    .widget-actions{
        display: none !important;
    }
    .widget-menu {
        display: none !important;
    }
    .widget-content {
        /* padding: ${constWidgetSize.padding}px !important; */
        padding-bottom: 0 !important;
        
       
    }
    .track-header{
        border: solid 1px solid !important;
    }
    .legend-toggler-container{
        button{
            display: none !important;
        }
    }
    //hidden Y axis 
    .statetimeline-widget{
        .x-axis-layer{
            visibility: hidden;
        }
    }
    
    ${ChartContainer}{        
        &:first-child{
            /* border: solid 1px red !important;     */
            padding-left:50px !important;
        }
    }

`
